{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -141.6012046780749,
              72.82753064248371
            ],
            [
              -164.44204860787883,
              71.57211897695106
            ],
            [
              -168.06381894636948,
              68.2954020323852
            ],
            [
              -170.3918828935104,
              61.47572865398763
            ],
            [
              -194.10748524471452,
              52.888037719192795
            ],
            [
              -117.0953624431742,
              32.49928306087908
            ],
            [
              -97.15560863287115,
              25.775959001217743
            ],
            [
              -79.54525199436156,
              23.497197385187974
            ],
            [
              -79.52862053839948,
              28.666171269704776
            ],
            [
              -66.39722597369624,
              41.63881948079515
            ],
            [
              -67.57457111962233,
              47.55875203982376
            ],
            [
              -86.24829033927024,
              49.40926759916505
            ],
            [
              -125.47624604638764,
              47.81708252037237
            ],
            [
              -140.5385145474753,
              59.5085064264849
            ],
            [
              -141.6012046780749,
              72.82753064248371
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}